"use client";
import * as React from "react";
const SvgContractSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h13.52v2.91h-1.5V1.45H1.5v13.1h9.02V16H0zm3 11.64h2.37v1.45H3zm9.81-7.96L16 6.76l-1.6 1.55-3.18-3.09zm-5.4 2.96 2.77-.37 3.17 3.07-.39 2.68-6.94 1.34zm1.7 3.74a.77.77 0 0 0 1.06 0 .7.7 0 0 0 0-1.03.77.77 0 0 0-1.06 0 .7.7 0 0 0 0 1.03", clipRule: "evenodd" }));
export {
  SvgContractSharp as default
};
